import _styled from "styled-components";
import { useTranslation } from 'next-i18next';
import { config } from '@restworld/utils-common';
import { CopyrightContainer, Divider, FooterColumnGroup, FooterColumnItem, FooterColumnItemGroup, FooterColumnTitle, FooterMainGrid, LogoAndSocials, SmartAndStartLogos, SocialIcons } from './footer.components';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var CopyrightText = function CopyrightText() {
  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: ["\xA9 Copyright ", new Date().getFullYear(), " ", t('footer.all_right_reserved_text')]
  });
};

var CopyrightSection = function CopyrightSection() {
  return /*#__PURE__*/_jsx(CopyrightContainer, {
    children: /*#__PURE__*/_jsx(CopyrightText, {})
  });
};

export var Footer = function Footer(_ref) {
  var copyrightOnly = _ref.copyrightOnly;

  var _useTranslation2 = useTranslation('common'),
      t = _useTranslation2.t;

  if (copyrightOnly) {
    return /*#__PURE__*/_jsx(_StyledFooter, {
      children: /*#__PURE__*/_jsx(_StyledDiv, {
        children: /*#__PURE__*/_jsx(CopyrightSection, {})
      })
    });
  }

  return /*#__PURE__*/_jsx(_StyledFooter2, {
    children: /*#__PURE__*/_jsxs(_StyledDiv2, {
      children: [/*#__PURE__*/_jsxs(FooterMainGrid, {
        children: [/*#__PURE__*/_jsx(LogoAndSocials, {}), /*#__PURE__*/_jsxs(_StyledDiv3, {
          children: [/*#__PURE__*/_jsxs(FooterColumnGroup, {
            children: [/*#__PURE__*/_jsx(FooterColumnTitle, {
              children: t('footer.for_talents')
            }), /*#__PURE__*/_jsxs(FooterColumnItemGroup, {
              children: [/*#__PURE__*/_jsx(FooterColumnItem, {
                href: "/cerco-lavoro",
                children: t('search_for_jobs')
              }), /*#__PURE__*/_jsx(FooterColumnItem, {
                href: "/",
                children: t('how_does_it_work')
              })]
            })]
          }), /*#__PURE__*/_jsxs(FooterColumnGroup, {
            children: [/*#__PURE__*/_jsx(FooterColumnTitle, {
              children: t('for_companies')
            }), /*#__PURE__*/_jsxs(FooterColumnItemGroup, {
              children: [/*#__PURE__*/_jsx(FooterColumnItem, {
                href: "https://restworld.typeform.com/to/oSu5piK6?utm_source=worker-app",
                newWindow: true,
                children: t('footer.hire_staff')
              }), /*#__PURE__*/_jsx(FooterColumnItem, {
                href: "/getting-started/freemium?utm_source=worker-app",
                children: t('footer.post_your_venue')
              }), /*#__PURE__*/_jsx(FooterColumnItem, {
                href: "/",
                children: t('how_does_it_work')
              })]
            })]
          }), /*#__PURE__*/_jsxs(FooterColumnGroup, {
            children: [/*#__PURE__*/_jsx(FooterColumnTitle, {
              children: t('footer.agency')
            }), /*#__PURE__*/_jsxs(FooterColumnItemGroup, {
              children: [/*#__PURE__*/_jsx(FooterColumnItem, {
                href: "/chi-siamo",
                children: t('who_we_are')
              }), /*#__PURE__*/_jsx(FooterColumnItem, {
                href: "/lavora-con-noi",
                children: t('work_with_us')
              }), /*#__PURE__*/_jsx(FooterColumnItem, {
                href: "https://restworld.it/collaborazioni/referral",
                children: t('footer.referral_program')
              })]
            })]
          }), /*#__PURE__*/_jsxs(FooterColumnGroup, {
            children: [/*#__PURE__*/_jsx(FooterColumnTitle, {
              children: t('footer.resources')
            }), /*#__PURE__*/_jsxs(FooterColumnItemGroup, {
              children: [/*#__PURE__*/_jsx(FooterColumnItem, {
                href: "https://help.restworld.it/",
                newWindow: true,
                children: "FAQ"
              }), /*#__PURE__*/_jsx(FooterColumnItem, {
                href: "/contatti",
                children: t('contact_us')
              }), /*#__PURE__*/_jsx(FooterColumnItem, {
                href: config.restworldPrivacyUrl,
                children: "Privacy policy"
              }), /*#__PURE__*/_jsx(FooterColumnItem, {
                href: config.restworldCookiePolicyUrl,
                children: "Cookie policy"
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx(SmartAndStartLogos, {}), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(CopyrightSection, {})]
    })
  });
};
export { SocialIcons };

var _StyledFooter = /*#__PURE__*/_styled("footer").withConfig({
  displayName: "footer___StyledFooter",
  componentId: "sc-1h378r6-0"
})({
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(249 250 251 / var(--tw-bg-opacity))",
  "fontSize": "1.125rem",
  "lineHeight": "1.75rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "fontSize": "1rem",
    "lineHeight": "1.5rem"
  }
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "footer___StyledDiv",
  componentId: "sc-1h378r6-1"
})({
  "width": "100%",
  "@media (min-width: 25.75rem)": {
    "maxWidth": "25.75rem"
  },
  "@media (min-width: 52rem)": {
    "maxWidth": "52rem"
  },
  "@media (min-width: 640px)": {
    "maxWidth": "640px"
  },
  "@media (min-width: 768px)": {
    "maxWidth": "768px"
  },
  "@media (min-width: 1024px)": {
    "maxWidth": "1024px",
    "paddingLeft": "5rem",
    "paddingRight": "5rem"
  },
  "@media (min-width: 1280px)": {
    "maxWidth": "1280px",
    "paddingLeft": "12rem",
    "paddingRight": "12rem"
  },
  "@media (min-width: 1536px)": {
    "maxWidth": "1536px"
  },
  "marginLeft": "auto",
  "marginRight": "auto",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "1.5rem",
  "paddingBottom": "1.5rem"
});

var _StyledFooter2 = /*#__PURE__*/_styled("footer").withConfig({
  displayName: "footer___StyledFooter2",
  componentId: "sc-1h378r6-2"
})({
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(249 250 251 / var(--tw-bg-opacity))",
  "paddingTop": "4rem",
  "fontSize": "1.125rem",
  "lineHeight": "1.75rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))",
  "@media (min-width: 768px)": {
    "fontSize": "1rem",
    "lineHeight": "1.5rem"
  }
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "footer___StyledDiv2",
  componentId: "sc-1h378r6-3"
})({
  "width": "100%",
  "@media (min-width: 25.75rem)": {
    "maxWidth": "25.75rem"
  },
  "@media (min-width: 52rem)": {
    "maxWidth": "52rem"
  },
  "@media (min-width: 640px)": {
    "maxWidth": "640px"
  },
  "@media (min-width: 768px)": {
    "maxWidth": "768px"
  },
  "@media (min-width: 1024px)": {
    "maxWidth": "1024px",
    "paddingLeft": "5rem",
    "paddingRight": "5rem"
  },
  "@media (min-width: 1280px)": {
    "maxWidth": "1280px",
    "paddingLeft": "12rem",
    "paddingRight": "12rem"
  },
  "@media (min-width: 1536px)": {
    "maxWidth": "1536px"
  },
  "marginLeft": "auto",
  "marginRight": "auto",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "3rem",
  "paddingBottom": "3rem"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "footer___StyledDiv3",
  componentId: "sc-1h378r6-4"
})({
  "display": "grid",
  "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
  "gap": "3rem",
  "@media (min-width: 768px)": {
    "gridColumn": "span 2 / span 2"
  },
  "@media (min-width: 1024px)": {
    "gridTemplateColumns": "repeat(4, minmax(0, 1fr))"
  }
});